import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

const getOptions = createSelector(
  get(['options']),
  get(['placeholder']),
  (options, placeholder) => {
    if (placeholder) {
      options = [
        { value: '', label: placeholder, isPlaceholder: true },
        ...options,
      ];
    }

    return options;
  },
);

export default {
  options: getOptions,
};
